export enum $Modals {
  ModalPatient = 'ModalPatient',
  modal_medical_records = 'modal_medical_records',
  view_images = 'view_images',
}

export type $ModalKeys = keyof typeof $Modals;

export type $ModalType = {
  status: boolean;
  key: $ModalKeys;
} & {
  [T in 'data' | 'action' | 'name' | 'filterName' | 'records' | 'title']?: any;
};

export type $ModalTypeObj = {
  [key in $ModalKeys]: {
    status?: boolean;
    data?: any;
  } & { [T: string]: any };
};
